import React from 'react'
import _ from 'lodash'

class EventCarouselItem extends React.PureComponent {
  constructor(props) {
    super(props)

    this.onFocus = this.onFocus.bind(this)
  }

  getCenteredBgImgStyle(imgUrl) {
    return { 
      background: `url(${imgUrl}?impolicy=resize&w=900&h=500)`, 
      backgroundSize: "cover", 
      backgroundPosition: "center",
      backgroundRepeat: 'no-repeat' 
    }
  }

  onFocus(e) {
    e.currentTarget.focus()
    this.props.onFocus(this.props.index)
  }

  render() {
    const gist = this.props.item.gist
    const eventImg = _.get(gist.imageGist, '_16x9', gist.landscapeImageUrl)    

    return (
      <div className="event-carousel-item">
        <div className="image-event" style={this.getCenteredBgImgStyle(eventImg)} />
        <div className="background-black" />
        {!this.props.noInfo && <div className="foot">
          <div className="text">
            <div className="title">{gist.title}</div>
            <div className="description">{gist.description}</div>
          </div>
          <div className="buttons">
            <a 
              aria-label={`Info for ${gist.title}`}
              onFocus={this.onFocus} 
              className="info" 
              href={gist.permalink}
            >
              Info
            </a>
            { gist.contentType === 'EVENT' && gist.ticketUrl &&  
              <a 
                aria-label={`Tickets for ${gist.title}`}
                onFocus={this.onFocus} 
                className="tickets cta" 
                href={gist.ticketUrl} 
                target="_blank"
              >
                Tickets
              </a>
            }
          </div>
        </div>}
      </div>
    )
  }
}

export default EventCarouselItem;